import PeopleIcon from "@mui/icons-material/People";
import { Chip, Stack, Tooltip, Typography } from "@mui/material";

interface Props {
  teammateQuotes: TeammateQuoteInfo[];
}

export function QuotedShipmentTeammateChip(props: Props) {
  const { teammateQuotes } = props;

  if (!teammateQuotes || teammateQuotes.length === 0) {
    return null;
  }

  const plural = teammateQuotes.length > 1;

  return (
    <Tooltip
      title={
        <Stack direction="row" spacing={0.5}>
          <Typography>
            <span>{teammateQuotes[0].first_name}</span>
            {plural ? (
              <span>
                {" "}
                and {teammateQuotes.length - 1}{" "}
                {teammateQuotes.length - 1 === 1 ? "other" : "others"}
              </span>
            ) : (
              ""
            )}
            <span>
              {" "}
              from your company {plural ? "have" : "has"} quoted this shipment
            </span>
          </Typography>
        </Stack>
      }
    >
      <Chip
        label="Quoted"
        color="warning"
        variant="outlined"
        size="small"
        icon={<PeopleIcon />}
      />
    </Tooltip>
  );
}
